import React, { useEffect, useState } from 'react';
import styles from './CalcFilter.module.scss';
import { Input, DateRangePicker } from 'tt-ui-lib/core';
import { SearchIcon } from 'tt-ui-lib/icons';

const CalcFilter = ({ setSearchedItems, items }) => {
  const [dateFilter, setDateFilter] = useState([null, null]);
  const [searchValue, setSearchValue] = useState('');

  const onSearchChange = (e) => {
    setSearchValue(e.target.value.toLowerCase());
  };
  const onDateChange = (value) => {
    setDateFilter(value);
  };

  const OnChangeFilter = () => {
    const searchedItems =
      searchValue || (dateFilter?.[0] && dateFilter?.[1])
        ? items.filter(
            (item) =>
              (!searchValue || item.name.toLowerCase().includes(searchValue.toLowerCase())) &&
              ((!dateFilter?.[0] && !dateFilter?.[1]) ||
                (item.updatedAt.getTime() >= dateFilter[0]?.startOf('day').$d.getTime() &&
                  item.updatedAt.getTime() <= dateFilter[1]?.endOf('day').$d.getTime()) ||
                (item.createdAt.getTime() >= dateFilter[0]?.startOf('day').$d.getTime() &&
                  item.createdAt.getTime() >= dateFilter[1]?.endOf('day').$d.getTime()))
          )
        : items;
    setSearchedItems(searchedItems);
  };

  useEffect(() => {
    OnChangeFilter();
  }, [dateFilter, searchValue, items]);

  return (
    <div className={styles.filterWrapper}>
      <DateRangePicker label="Date" value={dateFilter} onChange={onDateChange} />

      <Input
        className={styles.filter}
        prefix={<SearchIcon style={{ width: 20, height: 20 }} />}
        label="Search"
        value={searchValue}
        onChange={onSearchChange}
      />
    </div>
  );
};

export default CalcFilter;
